(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bws-nrc-category-tiles"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__bwsNrcTilesBound) return;
  window.__bwsNrcTilesBound = true;

  var EVENT_NAME = 'nrc_parts_category_click';
  var lastFire = { key: null, t: 0 };

  function handle(e) {
    if (e.type === 'auxclick' && e.button !== 1) return; // middle-click only
    var tile = e.target && e.target.closest ? e.target.closest('a[data-nrc-tile]') : null;
    if (!tile) return;
    var root = tile.closest('[data-nrc-tiles]');
    if (!root) return;

    var payload = {
      page_handle: root.getAttribute('data-page-handle') || '',
      tile_label: tile.getAttribute('data-tile-label') || '',
      collection_handle: tile.getAttribute('data-collection-handle') || '',
      collection_id: tile.getAttribute('data-collection-id') || '',
      tile_position: parseInt(tile.getAttribute('data-tile-position'), 10) || 0
    };

    // De-dupe accidental double fires (e.g. click + auxclick on some browsers)
    var key = payload.collection_handle + '|' + payload.tile_position;
    var now = Date.now();
    if (lastFire.key === key && now - lastFire.t < 400) return;
    lastFire = { key: key, t: now };

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(EVENT_NAME, payload);
      }
    } catch (err) { /* never block navigation */ }

    if (root.getAttribute('data-cart-attribution') === 'true') {
      try {
        var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(rootPath + 'cart/update.js', {
          method: 'POST',
          keepalive: true,
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            attributes: {
              nrc_tile_click: payload.collection_handle + ' | pos ' + payload.tile_position + ' | ' + payload.page_handle
            }
          })
        }).catch(function () {});
      } catch (err) { /* ignore */ }
    }
  }

  document.addEventListener('click', handle, true);
  document.addEventListener('auxclick', handle, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["proserieslanding"] && !Shopify.designMode) return;
  try {
    
(function() {
  if (window.proSeriesCartInit) return;
  window.proSeriesCartInit = true;

  // ───────────────────────────────────────────────
  // Variant select → update price + button state
  // ───────────────────────────────────────────────
  document.addEventListener('change', function(e) {
    var sel = e.target.closest('[data-variant-select]');
    if (!sel) return;
    var card = sel.closest('[data-pscard]');
    if (!card) return;
    var opt = sel.options[sel.selectedIndex];
    var priceEl = card.querySelector('[data-price]');
    if (priceEl && opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
    var addBtn = card.querySelector('[data-add-to-cart]');
    if (addBtn) addBtn.disabled = !!opt.disabled;
  });

  // ───────────────────────────────────────────────
  // Add-to-cart click → POST /cart/add.js
  // ───────────────────────────────────────────────
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled || btn.classList.contains('is-adding')) return;
    var card = btn.closest('[data-pscard]');
    if (!card) return;
    var sel = card.querySelector('[data-variant-select]');
    if (!sel || !sel.value) return showToast('Pick an option first', true);

    var variantId = parseInt(sel.value, 10);
    var title = btn.dataset.productTitle || 'Item';
    addToCart(variantId, 1, title, btn);
  });

  function addToCart(variantId, qty, title, btn) {
    btn.classList.add('is-adding');
    var originalLabel = btn.querySelector('.ps-acc__add__label');
    var originalText = originalLabel ? originalLabel.textContent : btn.textContent;
    if (originalLabel) originalLabel.textContent = 'Adding…';

    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    })
    .then(function(r) {
      if (!r.ok) return r.json().then(function(err) { throw new Error(err.description || 'Could not add to cart'); });
      return r.json();
    })
    .then(function(data) {
      btn.classList.remove('is-adding');
      btn.classList.add('is-added');
      if (originalLabel) originalLabel.textContent = 'Added!';
      showToast(title + ' added to cart');
      // Tell the theme so the cart drawer/icon updates
      refreshCartUI();
      setTimeout(function() {
        btn.classList.remove('is-added');
        if (originalLabel) originalLabel.textContent = originalText;
      }, 2500);
    })
    .catch(function(err) {
      btn.classList.remove('is-adding');
      if (originalLabel) originalLabel.textContent = originalText;
      showToast(err.message || 'Could not add to cart', true);
    });
  }

  // Try every common pattern for "open the cart drawer / refresh the icon"
  function refreshCartUI() {
    // 1. Custom events many themes (and apps) listen for
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:item-added'));
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    // Ritual / Roar Theme specifically dispatches these
    document.body.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('on:cart:after-merge'));
    // 2. Try opening common cart-drawer custom elements
    var drawer = document.querySelector('cart-drawer, [data-cart-drawer], #CartDrawer, .cart-drawer');
    if (drawer) {
      if (typeof drawer.open === 'function') { drawer.open(); return; }
      if (typeof drawer.show === 'function') { drawer.show(); return; }
      drawer.classList.add('is-active', 'is-open', 'active', 'open');
      drawer.setAttribute('open', '');
      return;
    }
    // 3. Click a cart trigger button if present
    var trigger = document.querySelector('[data-cart-drawer-trigger], [data-action="open-cart-drawer"], a[href="/cart"].header__cart-toggle');
    if (trigger) { trigger.click(); return; }
    // 4. Last-resort: refetch sections to keep the cart bubble accurate
    var bubble = document.querySelector('[data-cart-count], .cart-count-bubble, .header__cart-count');
    if (bubble) fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
      bubble.textContent = c.item_count;
    });
  }

  // ───────────────────────────────────────────────
  // Toast (used when no cart drawer is found, or for errors)
  // ───────────────────────────────────────────────
  function showToast(msg, isError) {
    var el = document.createElement('div');
    el.className = 'ps-toast' + (isError ? ' ps-toast--error' : '');
    el.textContent = msg;
    document.body.appendChild(el);
    requestAnimationFrame(function() { el.classList.add('is-visible'); });
    setTimeout(function() {
      el.classList.remove('is-visible');
      setTimeout(function() { el.remove(); }, 300);
    }, 2800);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
